<template>
    <div class="room">
        <b-row>
            <b-col cols="4">
                <b-form-group id="room_name" label="Nome" label-for="room_name">
                    <b-form-input
                        size="sm"
                        id="room_name"
                        v-model="room_name"
                        placeholder="Camera"
                        @input="updated"
                    ></b-form-input>
                </b-form-group>
            </b-col>
            <b-col cols="2">
                <b-form-group id="qty" label="N." label-for="qty">
                    <b-form-input
                        size="sm"
                        id="qty"
                        type="number"
                        v-model="qty"
                        placeholder="qty"
                        @input="updated"
                    ></b-form-input>
                </b-form-group>
            </b-col>
            <b-col cols="3">
                <b-form-group id="bedding" label="Bedding" label-for="bedding">
                    <b-form-input
                        size="sm"
                        id="bedding"
                        v-model="bedding"
                        placeholder="Bedding"
                        @input="updated"
                    ></b-form-input>
                </b-form-group>
            </b-col>
            <b-col cols="3">
                <b-form-group id="treatment" label="Trattamento" label-for="treatment">
                    <b-form-input
                        size="sm"
                        id="treatment"
                        v-model="treatment"
                        placeholder="Trattamento"
                        @input="updated"
                    ></b-form-input>
                </b-form-group>
            </b-col>
        </b-row>
    </div>
</template>

<script>
    export default
    {
        name: 'room',
        components: {
        },
        props: {
            room: {
                type: Object,
                default: () => {}
            },
            room_index: Number,
        },
        data() {
            return {     
                qty: this.room.qty,
                room_name: this.room.room_name,
                bedding: this.room.bedding,
                treatment: this.room.treatment,
            }
        },
        methods:
        {
            updated()
            {
                let payload = {
                    room_index: this.room_index,
                    room: {
                        ...this.room,
                        qty: this.qty,
                        room_name: this.room_name,
                        bedding: this.bedding,
                        treatment: this.treatment,
                    }
                }
                this.$emit('updated', payload)
            },
        }
    }
</script>

<style lang="scss">
    .hotel--room
    {
        .form-group
        {
            margin-bottom:0;
        }
        &:first-child
        {
            //margin-top:$grid-gutter-width/2;
        }
        &:not(:last-child)
        {
            margin-bottom:$grid-gutter-width/2;
        }
    }
</style>